var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.buscarEventoCalendario.apply(null, arguments);
      }
    }
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Evento do Calendário",
      "outlined": "",
      "dense": "",
      "maxlength": "70",
      "hide-details": ""
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('sca-select-ativo', {
    attrs: {
      "cols": 3,
      "config": {
        labelAtivo: 'Sim',
        labelInativo: 'Não',
        label: 'Dia Letivo'
      }
    },
    model: {
      value: _vm.form.filters.diaLetivo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "diaLetivo", $$v);
      },
      expression: "form.filters.diaLetivo"
    }
  }), _c('sca-select-ativo', {
    attrs: {
      "cols": 3,
      "config": {
        labelAtivo: 'Ativo',
        labelInativo: 'Inativo',
        label: 'Situação'
      }
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-submit-button'), _c('sca-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterEventoCalendario();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "no-data-text": _vm.noDataText
    },
    scopedSlots: _vm._u([{
      key: `item.diaLetivo`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.diaLetivo ? 'Sim' : 'Não') + " ")];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('sca-label-ativo', {
          attrs: {
            "ativo": item.ativo,
            "config": {
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo'
            }
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sca-tooltip', {
          attrs: {
            "text": 'Visualizar',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarEventoCalendario(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterEventoCalendario(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarEventoCalendario(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarEventoCalendarioDialog', {
    attrs: {
      "visible": _vm.dialogManterEventoCalendario.visible,
      "content": _vm.dialogManterEventoCalendario.content,
      "edit": _vm.dialogManterEventoCalendario.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterEventoCalendario.close();
      },
      "onSave": function ($event) {
        return _vm.buscarEventoCalendario();
      }
    }
  }), _vm.dialogVisualizarEventoCalendario.visible ? _c('VisualizarEventoCalendarioDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarEventoCalendario.visible,
      "content": _vm.dialogVisualizarEventoCalendario.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarEventoCalendario.close();
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }